// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.info-bar {
  position: relative;
  background-color: rgba(255, 150, 40, 0.25);
  color: #c17005;
  padding-top: 16px;
  padding-bottom: 16px;
  font-size: 14px;
  transform: translateZ(0);
  transition: max-height 0.4s;
}
.info-bar--level-info {
  background-color: rgba(161, 205, 226, 0.5);
  color: #138aae;
}
.info-bar__close-icon {
  font-size: 14px;
  position: absolute;
  top: 10px;
  right: 10px;
}
.info-bar__animation-enter {
  max-height: 0;
}
.info-bar__animation-enter-active {
  max-height: 100px;
}
.info-bar__animation-exit {
  max-height: 100px;
}
.info-bar__animation-exit-active {
  max-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/info-bar/InfoBar.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EAME,kBAAA;EACA,0CAAA;EACA,cAAA;EAEA,iBAAA;EACA,oBAAA;EAEA,eAAA;EACA,wBAAA;EACA,2BAAA;AAEF;AACI;EACE,0CAAA;EACA,cAAA;AACN;AAGE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AADJ;AAKI;EACE,aAAA;AAHN;AAKM;EACE,iBAAA;AAHR;AAOI;EACE,iBAAA;AALN;AAMM;EACE,aAAA;AAJR","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.info-bar {\n  @yellow-orange: #ff9628;\n  @yellow-ocher: #c17005;\n  @blue-steel: #a1cde2;\n  @blue-ocean: #138aae;\n\n  position: relative;\n  background-color: fade(@yellow-orange, 25);\n  color: @yellow-ocher;\n\n  padding-top: @layoutUnit-md;\n  padding-bottom: @layoutUnit-md;\n\n  font-size: @fontSize-sm;\n  transform: translateZ(0);\n  transition: max-height 0.4s;\n\n  &--level {\n    &-info {\n      background-color: fade(@blue-steel, 50);\n      color: @blue-ocean;\n    }\n  }\n\n  &__close-icon {\n    font-size: @fontSize-sm;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n  }\n\n  &__animation {\n    &-enter {\n      max-height: 0;\n\n      &-active {\n        max-height: 100px;\n      }\n    }\n\n    &-exit {\n      max-height: 100px;\n      &-active {\n        max-height: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
